import React, { lazy } from "react";
import { getAlbisCategories } from "services/InteractiveHelpers";
import { MagnoliaInteractiveGraphicAlbis } from "./MagnoliaInteractiveBuildingALBIS";

const Section = lazy(() => import("components/common/Section"));
const AlbisInteractiveElectrics = lazy(
  () => import("components/common/Markets/Graphics/AlbisInteractiveElectrics")
);

const MagnoliaInteractiveElectricsAlbis = ({
  title,
  multisite,
  description,
  ...props
}: MagnoliaInteractiveGraphicAlbis) => {
  // get categories displayed in the interactive image
  const categories = getAlbisCategories(props);

  return (
    <Section>
      <AlbisInteractiveElectrics
        description={description}
        title={title}
        categories={categories}
      />
    </Section>
  );
};

export default MagnoliaInteractiveElectricsAlbis;
